import { ResolutionString } from '../../lib/charting_library';

export const ChartStyles = {
  Line: {
    Solid: 0,
    Dotted: 1,
    Dashed: 2,
    LargeDashed: 3,
  },
  Color: {
    Blue: '#0a84ff',
    Yellow: '#ffb241',
    Background: '#111111',
    Line: 'rgba(221, 221, 221, 0.1)',
    Sub: '#ff6900',
    TriggerLong: '#2B5528',
    TriggerShort: '#622626',
    Up: '#0E8F5E',
    Down: '#F64444',
    CandleUp: '#34C759',
    CandleDown: '#FF4141',
    White: '#ffffff',
    Black: '#000000',
    Text1: '#000000',
    Text2: '#3c3c43',
    Text3: '#8a8a8e',
    Text4: '#c4c4c6',
    Text5: '#dcdcdd',
    Danger: '#ff4141',
    Border: {
      Light: '#171717',
      Dark: '#00ff00',
      Darker: '#0000ff',
    },
    Pick: {
      A: '#0fb9b9',
      B: '#6295ff',
      B05: 'rgba(98, 149, 255, 0.05)',
      B40: 'rgba(98, 149, 255, 0.4)',
      C: '#dd62ff',
      D: '#ff3695',
      E: '#ff8f47',
      E40: 'rgba(255, 143, 71, 0.4)',
      F: '#fbff54',
      G: '#90ff7b',
    },
  },
};

export const DefaultInterval = '1' as ResolutionString;
export const DefaultFavoriteIntervals = ['1', '5', '15', '60', '240', '1D'] as ResolutionString[];
export const SupportedResolutions = [
  '1', // 1m
  '3', // 3m
  '5', // 5m
  '15', // 15m
  '30', // 30m
  '60', // 1h
  '120', // 2h
  '240', // 4h
  '360', // 6h
  '720', // 12h
  '1D', // 1 day
  '1W', // 1 week
  '1M', // 1 month
] as ResolutionString[];
